var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StepComponent',[_c('PackageSelection',{on:{"state-change":_vm.onPackageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }